import Vue from "vue"
import imgUpload from "./img-upload.vue"
import fileUpload from "./file-upload.vue"

Vue.component("img-upload", imgUpload)
Vue.component("file-upload", fileUpload)
